'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickedMeetingsLinkAction = undefined;
exports.clickedMeetingsLink = clickedMeetingsLink;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var clickedMeetingsLinkAction = exports.clickedMeetingsLinkAction = (0, _reduxActions.createAction)(ActionTypes.CLICKED_MEETINGS_LINK);

function clickedMeetingsLink() {
  return function (dispatch) {
    dispatch(clickedMeetingsLinkAction());

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'clicked meeting link'
    }));
  };
}